module.exports = "./app-dist/fonts/spice.94b338b24cf09f161df122eafc347951.svg";